import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Chatbot from "@/components/Chatbot";
import Seo from "@/components/Seo";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import ServicePage from "@/pages/ServicePage";
import Saas from "@/pages/Saas";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Assessment from "@/pages/Assessment";
import ScrollToTop from "@/components/ScrollToTop";

const ROUTE_SEO = {
    "/": {
        title: "Consultoría, IA y aceleración comercial · Scalexa Group",
        description:
            "Consultoría de estrategia comercial, dirección externa e inteligencia artificial para pymes industriales y tecnológicas. Capta clientes y crece con método.",
    },
    "/services": {
        title: "Servicios de consultoría e IA para empresas · Scalexa Group",
        description:
            "Cinco líneas de consultoría para crecer: implementación de IA, aceleración comercial, prospección B2B, dirección empresarial y dirección de IA (CAIO externo).",
    },
    "/saas": {
        title: "SaaS de Scalexa — Próximamente · Scalexa Group",
        description:
            "Estamos preparando nuestra próxima solución SaaS. Recibe novedades sobre el producto y su disponibilidad.",
    },
    "/about": {
        title: "Nosotros · Scalexa Group",
        description:
            "Conoce Scalexa Group: consultora de estrategia comercial y transformación digital con IA. El criterio profesional dirige, la IA amplifica.",
    },
    "/contact": {
        title: "Contacto — Agenda una reunión · Scalexa Group",
        description:
            "Cuéntanos qué quieres lograr. Un socio de Scalexa Group te responde en menos de 24 horas hábiles. Madrid · Ciudad de México.",
    },
    "/assessment": {
        title: "Diagnóstico de crecimiento con IA · Scalexa Group",
        description:
            "Diagnóstico ejecutivo de 90 segundos: puntuación y recomendaciones para tu motor comercial y tu adopción de inteligencia artificial.",
    },
};

function RouteSeo() {
    const { pathname } = useLocation();
    if (pathname.startsWith("/services/")) return null; // ServicePage sets its own meta
    const meta = ROUTE_SEO[pathname];
    if (!meta) return null;
    return <Seo title={meta.title} description={meta.description} path={pathname} />;
}

function App() {
    return (
        <BrowserRouter>
            <ScrollToTop />
            <RouteSeo />
            <Navbar />
            <main className="pt-20">
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/services" element={<Services />} />
                    <Route path="/services/:slug" element={<ServicePage />} />
                    <Route path="/saas" element={<Saas />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/assessment" element={<Assessment />} />
                    <Route
                        path="/enterprise-ai"
                        element={<Navigate to="/services/consultoria-ia" replace />}
                    />
                </Routes>
            </main>
            <Footer />
            <Chatbot />
            <Toaster
                position="bottom-center"
                toastOptions={{
                    style: {
                        background: "#08256D",
                        color: "#fff",
                        border: "1px solid rgba(255,255,255,0.1)",
                        borderRadius: 0,
                    },
                }}
            />
        </BrowserRouter>
    );
}

export default App;
